import React,{useState,useEffect} from 'react'
import styled from "styled-components";
import { TitleText } from "../../../ui/Text";
import Table from "../../../ui/Table";
import Modal from "../../../ui/Modal";
import AddGroupForm from "./AddGroupForm"
import TableFormatter, {
  EditDeleteFormatter,
} from "../../../ui/TableFormatter";
import { GetHook } from "../../../api/api";
import {
  GROUPS_URL,
  ORGANISATION_URL,
  USER_URL,
} from "../../../api/urls";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import axios from "../../../utils/axios";
import { get } from "../../../utils/get";
const GroupSettings = () => {
  const [groups, setGroups] = useState([]);
  const [isModalOpen, setisModalOpen] = useState(false);
  const [handleSubmit, setHandleSubmit] = useState();
  const [editData, setEditData] = useState({});
  const [edit, setEdit] = useState(false);
  const { data, error, pending, reload } = GetHook(GROUPS_URL);
  const location = useLocation();

  useEffect(() => {
    setGroups(data);
    return () => {};
  }, [data]);

   const handleEdit: any = (row: any) => {
    setisModalOpen(true);
    setEdit(true);
    setEditData(row);
  };
  const handleDelete = (id: string) => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.value) {
        if (id) {
          axios
            .delete(`${GROUPS_URL}/${id}`)
            .then((res) => {
              setGroups(
                groups.filter((grp: any) => grp.id != id)
              );
              toast.success("Group deleted successfully");
              reload(get(location, "key"));
            })
            .catch((error) => toast.error(error.response.data.message));
            
        }
      }
    });
  };
   const closeModal = () => {
    setisModalOpen(false);
    setEdit(false);
    setEditData({});
    reload(get(location, "key"));
    
  };
 const columns = [
    {
      Header: "Group Name",
      accessor: "name",
    },
    {
      Header: "Owner",
      accessor: "names",
      Cell: ({ row }: any) => (
        <TableFormatter
          name={row.original.owner.names}
          url={row.original.url}
        />
      ),
    },
    {
      id: "1",
      Header: "",
      Cell: ({ row }: any) => (
        <EditDeleteFormatter
          showEdit={() => handleEdit(row.original)}
          handleDelete={() => handleDelete(row.original.id)}
        />
      ),
    },
  ];
  return (
    <div>
      <GroupContainer>
      <HeaderContainer>
        <TitleText>Group Settings</TitleText>
      </HeaderContainer>

      <Table
        data={groups}
        columns={columns}
        setModal={setisModalOpen}
      />
      {isModalOpen && (
        <Modal
          title={edit ? "Edit group" : "Add new group"}
          handleSubmit={handleSubmit}
          closeModal={closeModal}
        >
          <AddGroupForm
            closeModal={closeModal}
            setHandleSubmit={setHandleSubmit}
            editData={editData}
            groups={groups}
            setGroups={setGroups}
          />
        </Modal>
      )}
    </GroupContainer>
    </div>
  )
}


export default GroupSettings;
const GroupContainer = styled.div`
  display: grid;
  grid-template-rows: 5em auto;
  background-color: #fff;
`;
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.3em;
  border-bottom: 1px solid rgba(55, 81, 255, 0.1);
`;
